/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { FC, RefAttributes } from 'react';
import {
	createLayout,
	composeLayouts,
	type Layout,
} from '@jira/platform__layouts-route-layout/src/GlobalComponent.tsx';
import { lazyAfterPaint } from '@atlassian/react-loosely-lazy';
import { componentWithFG } from '@jira/platform__utils-feature-gates-gate-component/src/index.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';

export const RightSidebars: FC<RefAttributes<unknown>> = componentWithFG(
	'operations-migration-hub-jira',
	// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
	lazyAfterPaint(
		() =>
			import(
				/* webpackChunkName: "async-ops-migration-hub-right-sidebars" */ './ui/right-sidebars/index.tsx'
			),
		{ ssr: false },
	),
	() => null,
);
RightSidebars.displayName = 'RightSidebars';

export const Onboarding: FC<RefAttributes<unknown>> = componentWithFG(
	'operations-migration-hub-jira',
	// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
	lazyAfterPaint(
		() =>
			import(
				/* webpackChunkName: "async-ops-migration-hub-onboarding" */ './ui/onboarding/index.tsx'
			),
		{ ssr: false },
	),
	() => null,
);
Onboarding.displayName = 'Onboarding';

export const opsSettingsLayout: Layout = composeLayouts(globalSettingsLayout, {
	get globalComponents() {
		return [Onboarding];
	},
	rightSidebars: [RightSidebars],
});

export const opsMigrationHubLayout: Layout = createLayout({
	get globalComponents() {
		return [Onboarding];
	},
	rightSidebars: [RightSidebars],
});

export const opsNotificationsLayout: Layout = composeLayouts(globalLayout, {
	get globalComponents() {
		return [Onboarding];
	},
	rightSidebars: [RightSidebars],
});
